import * as React from "react";
const SvgAutomatic20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 16,
        fill: "black",
        viewBox: "0 0 17 16"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M6.5 7h1V5H3.624C4.645 3.163 6.327 2 8.5 2a6.003 6.003 0 0 1 5.752 4.285l1.917-.57A8.003 8.003 0 0 0 8.5 0c-2.589 0-4.638 1.223-6 3.06V0h-2v7h6Zm-4-2Zm.248 4.715A6.003 6.003 0 0 0 8.5 14c2.173 0 3.855-1.163 4.876-3H9.5V9h7v7h-2v-3.06c-1.362 1.837-3.411 3.06-6 3.06a8.003 8.003 0 0 1-7.668-5.715l1.916-.57Z",
      clipRule: "evenodd"
    })
  );
export default SvgAutomatic20Px;
